module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Black-Italic.f40c32ab.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Black-Italic.woff
// module id = 2195
// module chunks = 53